module.exports = __webpack_public_path__ + "media/images/icon-562f72e206a387f051972510a91036dc.svg";